import React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import CONTENT from "src/library/content.json";

import {
  PageTitle,
  SectionHeader,
  LinkToRegisterButton,
} from "src/library/components/exports";
import { verifyEmailAddress } from "src/library/api/api";
import { customButtonStyle } from "src/library/styles/theme";
import { RoutesEnum, VerifyResponses, VerifyMessages } from "src/library/types/types";

import { Link, useParams } from "react-router-dom";

export default function Verify() {
  const [loading, setLoading] = React.useState(true);
  const [isVerified, setIsVerified] = React.useState(false);
  const [verifyError, setVerifyError] = React.useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { ref } = useParams();
  const {
    pageTitles: { verify },
  } = CONTENT;

  React.useEffect(() => {
    if (typeof ref !== "string") return;
    (async () => {
      try {
        // LOADING IS SET TO TRUE UPON OPENING THE PAGE
        const resp = await (await verifyEmailAddress(ref)).json();
        if (
          resp.error === VerifyResponses.Error ||
          resp.error === VerifyResponses.Expired ||
          resp.error === VerifyResponses.NotFound
        ) {
          throw resp.error;
        }
        if (
          resp.msg === VerifyResponses.Success ||
          resp.msg === VerifyResponses.AlreadyVerified
        ) {
          setIsVerified(true);
        }
      } catch (error) {
        setVerifyError(true);
      } finally {
        setLoading(false);
      }
    })();
  }, [ref]);

  return (
    <Box sx={{ pt: isMobile ? "50px" : 0, minHeight: "75vh" }} component="main">
      <PageTitle title={verify} />
      <Container maxWidth="md" sx={{ pt: 8 }}>
        {!verifyError ? (
          <>
            {isVerified && !loading ? (
              <>
                {/* SUCCESS */}
                <SectionHeader text={VerifyMessages.Success} />
                <Link to={RoutesEnum.Home} style={{ textDecoration: "none" }}>
                  <Button
                    variant="contained"
                    color="secondary"
                    sx={customButtonStyle("large")}
                    component="button"
                  >
                    Back to Home
                  </Button>
                </Link>
              </>
            ) : (
              <>
                {/* LOADING */}
                <SectionHeader text={VerifyMessages.Loading} />
                <img
                  src="/images/spinner.gif"
                  alt="loading..."
                  style={{ width: "50px", height: "50px" }}
                />
              </>
            )}
          </>
        ) : (
          <>
            {/* ERROR */}
            <SectionHeader text={VerifyMessages.Error} />
            <LinkToRegisterButton buttonText="Register Your Interest" />
          </>
        )}
      </Container>
    </Box>
  );
}
